var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIconClaroTePresta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 86,
    viewBox: "0 0 76 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 86
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 0H0V86H80V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 91,
    height: 86
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8947 0H1.36841V86H91.8947V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.0221 86H12.654C8.39386 86 4.94183 83.0134 4.94183 79.3278V73.4816V61.7893V16.6722C4.94183 12.9866 8.39386 10 12.654 10H52.0221C56.282 10 59.7341 12.9866 59.7341 16.6722V79.3278C59.7341 83.0134 56.282 86 52.0221 86ZM8.32049 76.4047V79.3278C8.32049 81.4248 10.3036 83.0769 12.654 83.0769H52.0221C54.4459 83.0769 56.3555 81.4248 56.3555 79.3278V16.6722C56.3555 14.5753 54.4459 12.9231 52.0221 12.9231H12.654C10.2301 12.9231 8.32049 14.6388 8.32049 16.6722V58.8662V76.4047Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7645 80H35.9113",
    stroke: "#424242",
    strokeWidth: 1.66
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5291 17.0004C33.5291 17.5525 32.9961 18 32.3375 18C31.6799 18 31.1468 17.5525 31.1468 17.0004C31.1468 16.4475 31.6799 16 32.3375 16C32.9961 16 33.5291 16.4475 33.5291 17.0004Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0887 76L52.5873 75.9606V20H12.0887V76Z",
    fill: "#FF8300"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3379 37.8138C25.6478 37.8138 20.2048 42.3834 20.2048 48C20.2048 53.6166 25.6478 58.1872 32.3379 58.1872C39.0281 58.1872 44.4711 53.6166 44.4711 48C44.4711 42.3834 39.0281 37.8138 32.3379 37.8138ZM32.3379 61C23.7999 61 16.8532 55.168 16.8532 48C16.8532 40.832 23.7999 35 32.3379 35C40.876 35 47.8227 40.832 47.8227 48C47.8227 55.168 40.876 61 32.3379 61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4848 46.7132H33.8697V42H30.8052V46.7132H25.1912V49.2868H30.8052V54H33.8697V49.2868H39.4848V46.7132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2819 9.72043L69.7876 7.42329L64.6206 10.0231L66.115 12.3203L71.2819 9.72043Z",
    fill: "#FF7900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7282 2.2571L62.3484 0.637558L58.7056 4.77827L61.0855 6.39786L64.7282 2.2571Z",
    fill: "#FF7900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7761 16.1869L67.8716 16.8513L68.2534 19.4764L74.1581 18.812L73.7761 16.1869Z",
    fill: "#FF7900"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 86,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconClaroTePresta);
export default __webpack_public_path__ + "static/media/menuIcon-ClaroTePresta.d659d6880cdb8a0b8bca19b2157d7fb6.svg";
export { ForwardRef as ReactComponent };